<template>
  <v-layout>
    <MainMenu />
    <v-flex>
      <v-layout column>
        <listPagesHeader
          :page-title="$t('manage_swr.title')"
          :show-btn="false"
          class="none-growth"
        />
        <v-layout
          class="page-content-paddings"
          wrap
        >
          <v-flex
            v-for="(item, index) in managersList"
            :key="index"
            xs12
            class="mt-4"
          >
            <v-expansion-panel
              class="v-expansion-panel_inlined"
              readonly
              :value="0"
            >
              <ManageSwrUpload
                :title="item.title"
                :type="item.type"
              />
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import ListPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import ManageSwrUpload from '@/components/ManageSwr/ManageSwrUpload';
import permissions from '@/constants/permissions';
import csvTypes from '@/constants/csvTypes';

export default {
    name: 'ManageSwr',
    components: { ManageSwrUpload, ListPagesHeader, MainMenu },
    beforeRouteEnter (to, from, next) {
        next(async (vm) => {
            await vm.$store.dispatch('auth/permissionGuard', permissions.MANAGE_SWR);
            await vm.$store.dispatch('swrUpload/getCounters');
        });
    },
    data () {
        return {
            managersList: [
                { title: this.$t('manage_swr.bubbles.title'), type: csvTypes.BUBBLES },
                { title: this.$t('manage_swr.bubble_warehouses.title'), type: csvTypes.BUBBLE_WAREHOUSES },
                { title: this.$t('manage_swr.warehouse_families.title'), type: csvTypes.WAREHOUSE_FAMILIES }
            ]
        };
    }
};
</script>

<style scoped></style>
